import { render, staticRenderFns } from "./theatertreatment.vue?vue&type=template&id=b2831884&"
import script from "./theatertreatment.vue?vue&type=script&lang=js&"
export * from "./theatertreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports